import { NS_CONFIGURATION, SPRINT, EDITOR } from 'redux/constants';
import { action, createType, SYNC, ASYNC } from 'redux-create-type';

export const {
  OPEN,
  LOAD,
  CLOSE,
  SAVE,
  COMPLETE,
  ACTIVATE
} = createType(NS_CONFIGURATION, SPRINT, EDITOR)({
    OPEN: ASYNC,
    LOAD: ASYNC,
    CLOSE: SYNC,
    SAVE: ASYNC,
    COMPLETE: ASYNC,
    ACTIVATE: ASYNC
  });


export const open = {
  begin: ({ sprintId }) => action(OPEN.BEGIN, { sprintId }),
  end: ({ sprint }) => action(OPEN.END, { sprint }),
};
export const load = {
  begin: ({ sprintId }) => action(LOAD.BEGIN, { sprintId }),
  end: ({ sprint }) => action(LOAD.END, { sprint })
};

export const close = () => action(CLOSE);
export const save = {
  begin: ({
    sprintId,
    projectId,
    prevId,
    teamId,
    name,
    startDate,
    endDate,
    capacity,
    users,
    costOfEstimationUnit,
    costOfEstUnitInherit,
    status,
    isDeleted
  }) => action(SAVE.BEGIN, {
      sprintId,
      projectId,
      prevId,
      teamId,
      name,
      startDate,
      endDate,
      capacity,
      users,
      costOfEstimationUnit,
      costOfEstUnitInherit,
      status,
      isDeleted,
    }),
  end: () => action(SAVE.END),
};
export const complete = {
    begin: ({ sprintId }) => action(COMPLETE.BEGIN, { sprintId }),
    end: () => action(COMPLETE.END)
};
export const activate = {
    begin: ({ sprintId }) => action(ACTIVATE.BEGIN, { sprintId }),
    end: () => action(ACTIVATE.END)
};



// WEBPACK FOOTER //
// ../redux/store/configuration/sprint/editor/actions.js